
import React from 'react'

import Footer from '../../../general/footer/Footer';

import client2 from '../../../assets/client2.jpg'
import img2 from "../../../assets/img2.jpg";
import nriimg1 from "../../../assets/nriimg1.png";
import { Link } from 'react-router-dom';

const NRI = () => {
    return (
        <div>
            <div className="insurance-section">
                <div className="insurance-content">
                    <div className="breadcrumb">
                        <span>Home</span> &nbsp;•&nbsp;
                        <span>Our Services</span> &nbsp;•&nbsp;
                        <span className="active">NRI Corner</span>
                    </div>
                    <h1>NRI Corner</h1>
                    <p>
                        At PSJ Capital Ventures, we specialize in serving Non-Resident Indians (NRIs), Overseas Citizens of India (OCIs), and Persons of Indian Origin (PIOs) across the globe — helping them navigate the complex intersection of Indian financial regulations, investment opportunities, tax implications, and estate planning.
                    </p>
                </div>
                <div className="insurance-image">
                    <img src={nriimg1} alt="Insurance Family" />
                </div>
            </div>

            <div className="travel-details-container">
                {/* LEFT SECTION */}
                <div className="travel-details-left">
                    {/* <h2>Navigating Markets with a Macro Lens.</h2>
                    <p>
                       Whether you're a family office, corporate treasury, HNI investor, or portfolio manager, our macro research serves as the backbone for informed decision-making across asset classes - equities, debt, currency, commodities, and alternatives.
                    </p> */}


                    <h3 style={{ color: 'black' }}>What We Offer for NRIs</h3>

                    <h5>Investment Advisory & Execution</h5>
                    <ul>
                        <li>		Mutual Funds via NRE/NRO accounts (subject to FEMA/SEBI rules)</li>
                        <li>		PMS, AIFs, Pre-IPO deals, Private Credit</li>
                        <li>		Real estate investments (residential/commercial plots, pre-leased assets)</li>
                        <li>		Fixed deposits, bonds, and structured products</li>
                        <li>		US Dollar & FCNR-linked products (where applicable)</li>
                    </ul>

                    <h5>Banking & Account Setup</h5>
                    <ul>
                        <li>			NRE / NRO / FCNR account assistance</li>
                        <li>			Repatriation-compliant investment structuring</li>
                        <li>			Help with RBI LRS, FEMA guidelines, and 15CA/15CB compliance</li>
                    </ul>
                    <h5>Market Outlooks</h5>
                    <ul>
                        <li>		Equity market valuation metrics</li>
                        <li>		Sectoral rotation and leadership cycles</li>
                        <li>		Debt market trends — G-Sec yields, corporate bonds, credit spreads</li>
                        <li>		Gold, crude oil, and commodity cycles</li>
                    </ul>
                    <h5>Tax Planning & Compliance (via our associated CA partners)</h5>
                    <ul>
                        <li>			NRI Income Tax Return (ITR) Filing</li>
                        <li>			Capital Gains computation across asset classes</li>
                        <li>			DTAA (Double Tax Avoidance Agreement) optimization</li>
                        <li>			Rental income, interest income, dividend taxation</li>
                    </ul>
                    <h5>Global Coordination</h5>
                    <ul>
                        <li>				Collaboration with your foreign CA/tax advisor</li>
                        <li>				Help with disclosure of Indian assets in US, UK, UAE, etc. (FATCA, FBAR, CRS)</li>
                    </ul>


                    <h3 style={{ color: 'black' }}>NRI Investment Terminology – Simplified</h3>
                    <div className="plan-columns">

                        <div>
                            <h5>1. 	NRE Account </h5>
                            <p>Non-Resident External – Repatriable account for foreign income
                            </p>
                            <h5>2. 	NRO Account </h5>
                            <p>Non-Resident Ordinary – For income earned in India (non-repatriable beyond limits)</p>
                        </div>
                        <div>
                            <h5>3. 	FCNR Deposit </h5>
                            <p>Fixed deposit held in foreign currency</p>
                            <h5>4. 	DTAA </h5>
                            <p>Agreement to avoid double taxation between India & other countries</p>
                        </div>
                    </div>

                    {/* Service Benefits */}
                    <div className="benefits-section">
                        <div className="benefits-image">
                            <img src={img2} alt="Service Benefits" />
                        </div>
                        <div className="benefits-list">
                            <h4>Why NRIs Trust PSJ Capital Ventures</h4>
                            {/* <p>
                                We help you invest across a wide spectrum of mutual fund categories:
                            </p> */}
                            <ul>
                                <li>✓ 	•	End-to-End Partner   </li>
                                <li>✓ 	•	Single Relationship Point   </li>
                                <li>✓ 	•	Global Expertise   </li>
                                <li> ✓	•	Tax-Efficient Structuring   </li>
                                <li> ✓	•	Legacy + Liquidity   </li>
                                <li> ✓	•	Confidentiality & Governance    </li>
                            </ul>
                        </div>
                    </div>






                    {/* More Benefits */}
                    <div className="service-benefits">
                        <h3>Who Do We Serve?</h3>

                        <ul>
                            <li>✓ 		USA (with focus on tax implications under FATCA & PFIC rules)</li>
                            <li>✓ 		Canada</li>
                            <li>✓ 		UAE / GCC Region (Dubai, Abu Dhabi, Qatar, Oman, Saudi Arabia)</li>
                            <li>✓ 		Singapore & Southeast Asia</li>
                            <li>✓ 		Australia & New Zealand</li>
                            <li>✓ 		UK & Europe</li>
                            <li>✓ 		HNIs with Indian roots investing via NRE/NRO/OCB structures</li>
                        </ul>
                        <p>
                            Let Us Be Your India Partner

                            Whether you are a first-time investor in India, a seasoned NRI allocating serious capital, or simply looking to consolidate scattered Indian assets - PSJ Capital Ventures helps you simplify, strategize, and scale your wealth in India.

                            Book a personalized consultation with our NRI Wealth Desk today.


                        </p>
                    </div>
                    <Link to='/contact'><button className="get-touch-btn">Get in Touch →</button></Link>
                </div>

                {/* RIGHT SECTION */}
                <div className="travel-details-right">
                    <div className="services-box">
                        <h4>Our Services</h4>
                        <ul>
                            <Link to='/mutual-funds'><li>mutual-funds →</li></Link>
                            <Link to='/portfolio-management-services'><li>Portfolio Management Services →</li></Link>
                            <Link to='/alternative-investment-funds'><li>Alternative Investment Funds →</li></Link>
                            <Link to='/macro-treasury-research'><li>Macro/Treasury Research →</li></Link>
                            <Link to='/family-offices'><li>Family Offices →</li></Link>
                            <Link to='/insurance'><li>Insurance →</li></Link>
                            <Link to='/loan-syndication'><li>Loan Syndication→</li></Link>
                            <Link to='/sme-ipo-advisory'><li>SME IPO Advisory →</li></Link>
                            <Link to='/fundraising-assistance'><li>Fundraising Assistance →</li></Link>
                            <Link to='/stock-broking'><li>Stock Broking →</li></Link>
                        </ul>
                    </div>

                    <div className="advisor-box">
                        <img src={client2} alt="Advisor" />
                        <p>Make your dream life get professional help</p>
                        <div className="contact-info">
                            <span>📞 CONTACT US</span>
                            <p>+91 8108 430 942</p>
                        </div>
                    </div>
                </div>
            </div>
            <br></br><br></br><br></br>
            <Footer />
        </div>
    )
}

export default NRI